import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import { ToastContainer } from 'react-toastify'
import { ConnectedRouter } from 'connected-react-router'
import moment from 'moment'
import { registerLocale } from 'react-datepicker'
import { pdfjs } from 'react-pdf'
import L from 'leaflet'
import App from './App'
import store, { history } from './store'
import ptBR from 'date-fns/locale/pt-BR'
import 'moment/min/locales'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-toastify/dist/ReactToastify.css'
import 'leaflet/dist/leaflet.css'
import 'react-leaflet-markercluster/dist/styles.min.css'
import './assets/css/file-upload.css'

/* if (navigator && navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
  navigator.serviceWorker.getRegistration('/').then(registration => {
    if (registration) {
      registration.update()
      registration.unregister()
    }
  })
} */

registerLocale('pt-BR', ptBR)
moment.locale('pt-br')
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

const app = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ToastContainer />
      <App />
    </ConnectedRouter>
  </Provider>
)

ReactDOM.render(app, document.getElementById('root'))
